"use strict";
var ApiFlightCheckRequest = (function () {
    function ApiFlightCheckRequest() {
    }
    return ApiFlightCheckRequest;
}());
exports.ApiFlightCheckRequest = ApiFlightCheckRequest;
//# sourceMappingURL=D:/a/1/s/eligibility/src/models/api-flight-check-request.model.js.map


// WEBPACK FOOTER //
// ./~/@bhtp-client-api/eligibility/src/models/api-flight-check-request.model.js